import { Box } from "@mui/material";
import FrameGlassCard from "components/views/frame_glass_card";
import { FrameGlassType } from "utils/other/enums";

export default function ProjectSectionFrame(props) {
  return (
    <FrameGlassCard
      fullwidth={props.fullwidth ? true : false}
      type={FrameGlassType.Doff}
      borderRadius="18px"
      outline="2px solid rgba(255, 255, 255, 0.30);"
    >
      <Box sx={{ padding: "12px 24px", boxSizing: "border-box" }}>
        {props.children}
      </Box>
    </FrameGlassCard>
  );
}
